export default __webpack_public_path__ + "static/media/1006.ad302b8c.png";